module.exports = "/_next/static/images/projectEngeneeringBg-f313e1a6d8862d699b923653eed7af4a.webp";